import * as React from 'react';
import { PriceInsight } from '@shared-ui/lodging-property-offers';
import { RefTarget } from '@shared-ui/ref-context';
import { UitkSpacing } from 'uitk-react-spacing';
import { withSharedUiPropertyOffers } from './shared-ui-property-offers';
import { SimpleLazyLoadWrapper } from '../../../common/lazy/simple-lazy-load-wrapper';
const PriceInsightWrapper = ({
  inputs
}) => React.createElement(UitkSpacing, null, React.createElement(RefTarget, {
  name: "PriceInsight"
}, React.createElement(SimpleLazyLoadWrapper, null, React.createElement(PriceInsight, {
  inputs: inputs
}))));
export const SharedUiPriceInsightWrapper = withSharedUiPropertyOffers(PriceInsightWrapper);
SharedUiPriceInsightWrapper.displayName = 'SharedUiPriceInsightWrapper';